import { useEffect, useRef } from "react";

const useDismissibleLayer = ({
  isOpen,
  onClose,
  containerRef,
  returnFocusRef,
  lockBodyScroll = false,
  closeOnEscape = true,
  closeOnPointerDownOutside = true,
}) => {
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (!lockBodyScroll) {
      return undefined;
    }

    document.body.style.overflow = isOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, lockBodyScroll]);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (!closeOnPointerDownOutside || !containerRef?.current) {
        return;
      }

      if (!containerRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleKeyDown = (event) => {
      if (closeOnEscape && event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [closeOnEscape, closeOnPointerDownOutside, containerRef, isOpen, onClose]);

  useEffect(() => {
    if (wasOpenRef.current && !isOpen) {
      returnFocusRef?.current?.focus();
    }

    wasOpenRef.current = isOpen;
  }, [isOpen, returnFocusRef]);
};

export default useDismissibleLayer;
